import * as React from 'react';
import PropTypes from 'prop-types';

const SvgActionsVisibleDisabledNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M3.16 20.03l1.5-.8A15.61 15.61 0 012.36 16a15.516 15.516 0 0120.63-6.52l1.75-.93A17.155 17.155 0 00.69 15.63L.51 16l.18.37a16.799 16.799 0 002.47 3.66zm25.68-8.06l-1.5.8c.9.975 1.674 2.06 2.3 3.23A15.378 15.378 0 0116 24.17a15.474 15.474 0 01-6.99-1.65l-1.75.93a17.156 17.156 0 0024.05-7.08l.18-.37-.18-.37a16.797 16.797 0 00-2.47-3.66z"
        fill=""
      />
      <path
        d="M9.17 16c0 .268.02.535.06.8l1.6-.85A5.18 5.18 0 0116 10.83c1.011-.002 2 .297 2.84.86l1.6-.85A6.74 6.74 0 0016 9.17 6.846 6.846 0 009.17 16zm13.66 0c0-.268-.02-.535-.06-.8l-1.6.85A5.18 5.18 0 0116 21.17c-1.011.002-2-.297-2.84-.86l-1.6.85A6.74 6.74 0 0016 22.83 6.846 6.846 0 0022.83 16zm3.45-6.4L0 23.58v1.86L32 8.42V6.56L26.28 9.6z"
        fill=""
      />
    </svg>
  )
);
SvgActionsVisibleDisabledNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgActionsVisibleDisabledNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgActionsVisibleDisabledNormalMedium;
